module.exports = __webpack_public_path__ + "assets/favicons/favicon.ico";